var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-footer copyright"},[_c('a',{attrs:{"href":"https://www.dxrj.cn/","target":"_blank"}},[_vm._v("Copyright © 2016-"+_vm._s(_vm.year)+" 陕西大虾软件科技有限公司  版权所有")])])
}
var staticRenderFns = []

export { render, staticRenderFns }